import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FiUser, FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

export default function Signup() {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '', emailSubscribed: true });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      return toast.error('Passwords do not match');
    }
    if (form.password.length < 6) {
      return toast.error('Password must be at least 6 characters');
    }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/signup', {
        name: form.name,
        email: form.email,
        password: form.password,
        emailSubscribed: form.emailSubscribed
      });
      toast.success('Account created! Check your email for verification code.');
      navigate(`/verify?userId=${data.userId}`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <h1 style={styles.logoText}>ReplyCraft</h1>
          <p style={styles.tagline}>Create your free account</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <FiUser style={styles.inputIcon} />
            <input name="name" type="text" placeholder="Full name" value={form.name} onChange={handleChange} required style={styles.input} />
          </div>

          <div style={styles.inputGroup}>
            <FiMail style={styles.inputIcon} />
            <input name="email" type="email" placeholder="Email address" value={form.email} onChange={handleChange} required style={styles.input} />
          </div>

          <div style={styles.inputGroup}>
            <FiLock style={styles.inputIcon} />
            <input name="password" type={showPassword ? 'text' : 'password'} placeholder="Password (min 6 chars)" value={form.password} onChange={handleChange} required style={styles.input} />
            <button type="button" onClick={() => setShowPassword(!showPassword)} style={styles.eyeBtn}>
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>

          <div style={styles.inputGroup}>
            <FiLock style={styles.inputIcon} />
            <input name="confirmPassword" type="password" placeholder="Confirm password" value={form.confirmPassword} onChange={handleChange} required style={styles.input} />
          </div>

          <label style={styles.checkboxLabel}>
            <input type="checkbox" name="emailSubscribed" checked={form.emailSubscribed} onChange={handleChange} style={styles.checkbox} />
            <span>Send me product updates and tips</span>
          </label>

          <button type="submit" disabled={loading} style={styles.submitBtn}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p style={styles.footerText}>
          Already have an account? <Link to="/login" style={{ color: 'var(--accent)', fontWeight: 600 }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', padding: 20 },
  card: { width: '100%', maxWidth: 420, background: 'var(--bg-secondary)', borderRadius: 16, padding: '40px 32px', border: '1px solid var(--border)' },
  logo: { textAlign: 'center', marginBottom: 32 },
  logoText: { fontSize: 28, fontWeight: 700, color: 'var(--accent)', marginBottom: 4 },
  tagline: { color: 'var(--text-secondary)', fontSize: 14 },
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
  inputGroup: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputIcon: { position: 'absolute', left: 14, color: 'var(--text-muted)', fontSize: 18 },
  input: { width: '100%', padding: '14px 14px 14px 44px', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-primary)', fontSize: 15, outline: 'none' },
  eyeBtn: { position: 'absolute', right: 14, background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 18, cursor: 'pointer' },
  checkboxLabel: { display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: 14, cursor: 'pointer' },
  checkbox: { width: 18, height: 18, accentColor: 'var(--accent)' },
  submitBtn: { padding: '14px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer' },
  footerText: { textAlign: 'center', marginTop: 24, color: 'var(--text-secondary)', fontSize: 14 }
};
